import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import Breadcrumbs from "../based/Breadcrumbs";
import OrderServices from "../based/services/OrderServices";
import { INITPAGING, NOTIFY } from "../based/Constants";
import Common from "../based/Common";
import FinancePartnerModal from "./FinancePartnerModal";
import PostponeModal from "./PostponeModal";
import TransferManualModal from "./TransferManualModal";
import FinanceServices from "../based/services/FinanceServices";
import { Notify } from "../based/Notify";
import TableFooter from "../based/content/TableFooter";

//tất cả/đợi hoàn/thành công/đã hủy
const TAB_SCREEN = [
    { label: "Thanh toán không theo kỳ", value: 0 },
    { label: "Thanh toán theo kỳ", value: 1 },
    { label: "Lịch sử giao dịch", value: 2 },
];

const SUB_TAB_SCREEN = [
    { label: "Tất cả", value: -1 },
    { label: "Chờ thanh toán", value: 0 },
    { label: "Tạm hoãn", value: 3 },
    { label: "Thất bại", value: 2 },
    { label: "Hoàn thành", value: 1 },
];

function FinanceManagementOverview(props) {
    const [models, setModels] = useState([]);
    const [paging, setPaging] = useState({ ...INITPAGING, status: -1, walletTabScreen: 0 });
    const [showModal, setShowModal] = useState(false);
    const [showPostponeModal, setShowPostponeModal] = useState(false);
    const [showTransferModal, setShowTransferModal] = useState(false);
    const [walletId, setWalletId] = useState(null);

    useEffect(() => {
        getData(paging);
    }, []);

    const _renderTab = useMemo(() => (
        <ul className="nav nav-tabs tabs-bordered">
            {TAB_SCREEN.map((item, index) => {
                return (
                    <li key={index} className="nav-item">
                        <a
                            className={paging.walletTabScreen == item.value ? "nav-link active" : "nav-link btn-light"}
                            onClick={() => {
                                var page = { ...paging, walletTabScreen: item.value };
                                if (item.value == 2) page.status = -1;
                                getData(page);
                            }}
                        >
                            <span>{item.label}</span>
                        </a>
                    </li>
                );
            })}
        </ul>
    ));

    const _renderSubTab = useMemo(() => (
        <ul className="nav nav-tabs tabs-bordered">
            {paging.walletTabScreen == 0 || paging.walletTabScreen == 1
                ? SUB_TAB_SCREEN.map((item, index) => {
                      return (
                          <li key={index} className="nav-item">
                              <a
                                  className={paging.status == item.value ? "nav-link active" : "nav-link btn-light"}
                                  onClick={() => {
                                      getData({ ...paging, status: item.value });
                                  }}
                              >
                                  <span>{item.label}</span>
                              </a>
                          </li>
                      );
                  })
                : null}
        </ul>
    ));

    const getData = async (page) => {
        const [err, data] = await FinanceServices.GetTicketPaymentHistoryModels(page);
        if (!err && data) {
            setModels(data.listObjects);
            setPaging(data.paging);
        } else {
            setModels([]);
            setPaging(page);
        }
    };

    return (
        <>
            <Wrapper>
                <Breadcrumbs currentPage="Quản lý tài chính Partner" />
                {_renderTab}
                {_renderSubTab}
                <section className="table-refund">
                    {paging.walletTabScreen == 0 || paging.walletTabScreen == 1 ? (
                        <>
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th scope="col">Thông tin giao dịch</th>
                                        <th scope="col">Loại ví</th>
                                        <th scope="col">Số tiền rút</th>
                                        <th scope="col">Tài khoản rút về</th>
                                        <th scope="col">Trạng thái</th>
                                        <th scope="col">Thao tác</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {models && models.length > 0 ? (
                                        models.map((item, index) => {
                                            let statusClsName = "";
                                            if (item.status === 0) statusClsName = "in-progress";
                                            else if (item.status === 1) statusClsName = "success";
                                            else if (item.status === 2) statusClsName = "failed";
                                            return (
                                                <tr key={index}>
                                                    <td className="vertical-align-middle">
                                                        <div className="transaction-info">
                                                            <div className="brand-info"></div>
                                                            <div className="form-group">
                                                                <label htmlFor="">Mã giao dịch</label>
                                                                <span
                                                                    className="cursor-pointer"
                                                                    onClick={(e) => {
                                                                        navigator.clipboard.writeText(item.walletId);
                                                                        Notify(NOTIFY.INFO, NOTIFY.INFO, "Đã sao chép mã giao dịch");
                                                                    }}
                                                                >
                                                                    {item.walletId} <i className="fa fa-copy"></i>
                                                                </span>
                                                            </div>
                                                            <div className="form-group">
                                                                <label htmlFor="">Ngày yêu cầu</label>
                                                                <span>{Common.formatDate(new Date(item.createdDate))}</span>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="vertical-align-middle">
                                                        <span className={`wallet-type ${item.walletType === 0 ? "royalty" : "production"}`}>Ví {item.walletTypeName}</span>
                                                    </td>
                                                    <td className="vertical-align-middle">
                                                        <div className="withdrawl-info">
                                                            <div className="form-group">
                                                                <label htmlFor="">Số tiền rút</label>
                                                                <span>
                                                                    <strong>{Common.formatCurrency(Math.abs(item.amount))}</strong>
                                                                </span>
                                                            </div>
                                                            <div className="form-group">
                                                                <label htmlFor="">Số dư</label>
                                                                <span>{Common.formatCurrency(item.walletAmount)}</span>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="vertical-align-middle">
                                                        <div className="bank-info">
                                                            <p>
                                                                {item.bankName}
                                                                <br />
                                                                {item.bankAccountNumber}
                                                                <br />
                                                                {item.bankAccountName}
                                                            </p>
                                                        </div>
                                                    </td>
                                                    <td className="vertical-align-middle">
                                                        <div className="status-badge">
                                                            <span className={`status ${statusClsName}`}>{item.statusName}</span>
                                                        </div>
                                                    </td>
                                                    <td className="vertical-align-middle">
                                                        <div className="lst-action">
                                                            <button
                                                                className="btn btn-custom"
                                                                onClick={(e) => {
                                                                    setWalletId(item.walletId);
                                                                    setShowModal(true);
                                                                }}
                                                            >
                                                                Chuyển
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan={6} className="text-center">
                                                <p>Không có dữ liệu</p>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <TableFooter paging={paging} onFilter={(newPaging) => getData(newPaging)} />
                        </>
                    ) : (
                        <>
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Partner</th>
                                        <th>Thời gian</th>
                                        <th>Mã giao dịch</th>
                                        <th>Loại giao dịch</th>
                                        <th>Số tiền</th>
                                        <th>Số dư sau giao dịch</th>
                                        <th>Tài khoản ngân hàng rút về</th>
                                        <th>Trạng thái</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {models && models.length > 0 ? (
                                        models.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td className="vertical-align-middle">
                                                        <p>{item.displayName}</p>
                                                    </td>
                                                    <td className="vertical-align-middle">{Common.formatDate(new Date(item.createdDate))}</td>
                                                    <td className="vertical-align-middle">
                                                        <span
                                                            className="cursor-pointer"
                                                            onClick={(e) => {
                                                                navigator.clipboard.writeText(item.walletId);
                                                                Notify(NOTIFY.INFO, NOTIFY.INFO, "Đã sao chép mã giao dịch");
                                                            }}
                                                        >
                                                            {item.walletId} <i className="fa fa-copy"></i>
                                                        </span>
                                                    </td>
                                                    <td className="vertical-align-middle">
                                                        <div className="transaction-type">{item.transactionTypeName}</div>
                                                    </td>
                                                    <td className="vertical-align-middle">
                                                        <div className="transaction-amount">{Common.formatCurrency(Math.abs(item.amount))}</div>
                                                    </td>
                                                    <td className="vertical-align-middle">
                                                        <div className="transaction-after">
                                                            <div className="amount-type">{item.walletTypeName}</div>
                                                            <div className="amount-value">{Common.formatCurrency(Math.abs(item.walletAmount - item.walletAmountOnHold + item.amount))}</div>
                                                        </div>
                                                    </td>
                                                    <td className="vertical-align-middle">
                                                        {item.bankName && (
                                                            <div className="transaction-bank">
                                                                <span className="bank-name">{item.bankName}</span>
                                                                <span className="bank-account-number">{item.bankAccountNumber}</span>
                                                                <span className="bank-account-name">{item.bankAccountName}</span>
                                                                <div className="image-description">
                                                                    {item.transferDescription && (
                                                                        <span
                                                                            className="cursor-pointer"
                                                                            onClick={(e) => {
                                                                                window.open(item.transferDescription, "_blank");
                                                                            }}
                                                                        >
                                                                            Ảnh chuyển khoản <i className="fa fa-pull-right"></i>
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </td>
                                                    <td className="vertical-align-middle">
                                                        <div className="status-label">{item.statusName}</div>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan={8} className="text-center">
                                                <p>Không có dữ liệu</p>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <TableFooter paging={paging} onFilter={(newPaging) => getData(newPaging)} />
                        </>
                    )}
                </section>
            </Wrapper>
            <FinancePartnerModal
                show={showModal}
                onClose={() => setShowModal(false)}
                walletId={walletId}
                onPostpone={() => {
                    setShowModal(false);
                    setShowPostponeModal(true);
                }}
                onManual={() => {
                    setShowTransferModal(true);
                }}
            />
            <PostponeModal
                show={showPostponeModal}
                onClose={() => setShowPostponeModal(false)}
                walletId={walletId}
                onSave={() => {
                    setWalletId(0);
                    setShowPostponeModal(false);
                    getData({ ...paging });
                }}
            />
            <TransferManualModal
                show={showTransferModal}
                onClose={() => setShowTransferModal(false)}
                walletId={walletId}
                onSave={() => {
                    setWalletId(0);
                    setShowTransferModal(false);
                    getData({ ...paging });
                }}
            />
        </>
    );
}

export default FinanceManagementOverview;

const Wrapper = styled.div`
    td.vertical-align-middle p {
        margin-bottom: 0;
    }

    .transaction-amount {
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    .transaction-amount.success {
        color: #28b259;
    }

    .transaction-amount.in-progress {
        color: #ff9027;
    }

    .transaction-amount.failed {
        color: #d70000;
    }

    .amount-type {
        font-family: Roboto;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .amount-type.production {
        color: #28b259;
    }

    .amount-type.royalty {
        color: #ff9027;
    }

    .amount-value {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-top: 4px;
    }

    .transaction-bank {
        display: flex;
        flex-direction: column;
    }

    .image-description {
        text-align: right;
    }

    .image-description span {
        overflow: hidden;
        color: #64c5b1;
        text-overflow: ellipsis;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    .transaction-bank span {
        margin: 2px 0;
    }

    .status-label {
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .in-progress.status-label {
        color: #ff9027;
    }

    .success.status-label {
        color: #64c5b1;
    }

    .failed.status-label {
        color: #d70000;
    }

    tbody tr .form-group {
        margin-bottom: 6px;
        display: flex;
        align-items: center;
    }

    tbody tr .form-group label {
        margin: 0;
        width: 40%;
    }

    tbody tr .form-group span {
        flex: 1;
    }

    .transaction-info {
        width: 300px;
    }

    .withdrawl-info {
        width: 180px;
    }

    span.wallet-type {
        width: 100px;
        display: block;
    }

    tbody tr {
        background: white;
    }

    .bank-info p {
        margin: 0;
    }

    .bank-info {
        width: 300px;
    }

    thead tr th {
        border: 1px solid #d9d9d9;
        background: #d9d9d9;
    }

    section.table-refund {
        margin: 12px 0;
    }

    .refund-detail {
        display: flex;
        flex-direction: column;
        width: 200px;
    }

    .lst-image img {
        width: 90px;
        height: 90px;
        object-fit: contain;
        margin: 5px;
    }

    .lst-image {
    }

    p.refund-money span {
        color: #444;
        text-align: center;
        font-family: Roboto;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    .badge.badge-custom {
        border-radius: 30px;
        background: #28b259;
        color: #fff;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
        margin: 4px;
    }
`;
